module.exports = __webpack_public_path__ + "img/block0Img02.0b40ece7.png";